import { render, staticRenderFns } from "./ApproveStudentChangeRequest.vue?vue&type=template&id=7b971ad8&"
import script from "./ApproveStudentChangeRequest.vue?vue&type=script&lang=js&"
export * from "./ApproveStudentChangeRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports